import type { IButtonState, IButtonTo } from "@/common/button";
import { Button } from "@/common/button";
import { EButtonType } from "@/common/button/button-models";
import { defined } from "@/utils/variable-evaluation";
import React from "react";

export const LinkConditional = React.memo(function LinkConditional(props: {
  isDisabled: boolean;
  to?: IButtonTo | null;
  state?: IButtonState;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  type?: EButtonType;
  children?: React.ReactNode;
}) {
  if (defined(props.to) || defined(props.onClick)) {
    // `to` makes Button render a react-router <Link>, which throws if this
    // tree is mounted outside a <Router> (e.g. the /mobile webview root in
    // src/index.tsx). Callers reachable from there must omit `to` or pass
    // an onClick-only fallback instead.
    return (
      <Button
        isDisabled={props.isDisabled}
        to={props.to}
        state={props.state}
        onClick={props.onClick}
        buttonType={defined(props.type) ? props.type : EButtonType.NoStyle}
      >
        {props.children}
      </Button>
    );
  } else {
    return <>{props.children}</>;
  }
});
